import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import '@maplibre/maplibre-gl-leaflet';

/**
 * Renders a MapLibre GL vector layer inside a react-leaflet MapContainer.
 * Must be placed as a child of <MapContainer>.
 *
 * @param {{ styleUrl: string }} props
 */
export default function MapLibreGLLayer({ styleUrl }) {
    const map = useMap();

    useEffect(() => {
        if (!styleUrl) return;

        const glLayer = L.maplibreGL({ style: styleUrl, pane: 'tilePane' });
        glLayer.addTo(map);

        return () => {
            map.removeLayer(glLayer);
        };
    }, [map, styleUrl]);

    return null;
}
